/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const TypesTab = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
        <TabsContent value="types" className="mt-4 space-y-4">
          <ReferentielsManager
            kind="types-demande"
            title="Types de demande / tarif"
            accentColor="amber"
            onChange={() => loadReferentielsFromApi()}
            extraFields={[
              { key: 'icon', label: 'Icone (emoji)', type: 'text', placeholder: '💵', metaKey: true },
              { key: 'color', label: 'Couleur (slate/blue/emerald/...)', type: 'text', placeholder: 'blue', metaKey: true },
            ]}
          />
          {/* HERO BANNER */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0a1e3f] via-[#0B3C5D] to-[#0a1e3f] text-white shadow-lg ring-1 ring-slate-200">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#fbbf24] to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#fbbf24]/60 to-transparent" />
            <div className="absolute -right-12 -top-12 w-48 h-48 rounded-full bg-[#fbbf24]/10 blur-3xl pointer-events-none" />
            <div className="relative p-5 md:p-6 flex flex-col lg:flex-row lg:items-end justify-between gap-5">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
                  <Tag className="h-7 w-7 text-[#fbbf24]" />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#fbbf24]/90 font-medium mb-1" style={{ fontFamily: '"Outfit", system-ui, sans-serif' }}>O&apos;SCOP · Grille tarifaire par espace</div>
                  <h2 className="text-2xl md:text-3xl font-bold leading-tight tracking-tight" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>Tarifs par Type de Demande</h2>
                  <p className="text-sm text-white/75 mt-1">Personnalisez les prix CB, crédits et coefficient d&apos;urgence pour chaque espace utilisateur.</p>
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                {activeSpaceTarif !== 'default' && (
                  <Button
                    onClick={handleCloneFromDefault}
                    size="sm"
                    variant="outline"
                    className="bg-white/10 border-white/30 text-white hover:bg-white/20"
                    data-testid="clone-from-default-btn"
                  >
                    <Copy className="h-4 w-4 mr-1.5" />Cloner depuis default
                  </Button>
                )}
                <Button
                  onClick={handleSaveAllConfigTypeSpace}
                  size="sm"
                  className="bg-[#fbbf24] hover:bg-amber-400 text-[#0a1e3f] font-semibold"
                  data-testid="save-all-types-btn"
                >
                  <Save className="h-4 w-4 mr-1.5" />Sauvegarder tout l&apos;espace
                </Button>
              </div>
            </div>
          </div>

          {/* BLOC GESTION DES TYPES MAÎTRES — créer / dupliquer / supprimer en masse */}
          <TypesMaitresManager />

          {/* SPACE SELECTOR */}
          <Card className="border-0 shadow-md">
            <CardContent className="p-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-1 h-5 bg-[#fbbf24] rounded-full" />
                <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-700" style={{ fontFamily: '"Outfit", system-ui, sans-serif' }}>
                  Espace utilisateur cible
                </h4>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {[
                  { value: 'default', label: 'Par défaut', sub: 'Admin · Partenaire', icon: '🏛️', color: 'slate' },
                  { value: 'member',  label: 'Membre',     sub: 'Adhérents particuliers', icon: '👤', color: 'blue' },
                  { value: 'cooper',  label: "COOPER'S",   sub: 'Coopérateurs terrain', icon: '🤝', color: 'teal' },
                  { value: 'expert',  label: 'Expert',     sub: "Production d'expertise", icon: '⭐', color: 'rose' },
                ].map(sp => {
                  const isActive = activeSpaceTarif === sp.value;
                  const hasDirty = Object.values(dirtyTypeBySpace[sp.value] || {}).some(Boolean);
                  return (
                    <button
                      key={sp.value}
                      type="button"
                      onClick={() => setActiveSpaceTarif(sp.value)}
                      data-testid={`tarif-space-${sp.value}`}
                      className={`relative text-left p-3 rounded-xl border-2 transition-all ${
                        isActive
                          ? `border-${sp.color}-600 bg-${sp.color}-50 shadow-md scale-[1.02]`
                          : 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm'
                      }`}
                    >
                      <div className="flex items-start justify-between gap-2">
                        <div className="text-2xl">{sp.icon}</div>
                        {hasDirty && (
                          <span className="flex items-center gap-1 text-[9px] uppercase tracking-wider font-bold text-amber-700 bg-amber-100 border border-amber-200 px-1.5 py-0.5 rounded-full">
                            <span className="w-1 h-1 rounded-full bg-amber-500 animate-pulse" />Modif.
                          </span>
                        )}
                      </div>
                      <div className={`mt-2 font-bold text-sm ${isActive ? `text-${sp.color}-900` : 'text-slate-900'}`} style={{ fontFamily: '"Outfit", system-ui, sans-serif' }}>{sp.label}</div>
                      <div className="text-[10px] text-slate-500 mt-0.5">{sp.sub}</div>
                    </button>
                  );
                })}
              </div>
            </CardContent>
          </Card>

          {/* CARDS GRID — TARIF PAR TYPE */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {TARIF_TYPES.map(type => {
              const cfg = configParTypeBySpace[activeSpaceTarif]?.[type.value] || emptyTypeConfig();
              const isDirty = dirtyTypeBySpace[activeSpaceTarif]?.[type.value];
              return (
                <Card
                  key={type.value}
                  className={`group relative overflow-hidden border ${isDirty ? 'border-amber-300 ring-2 ring-amber-200' : 'border-slate-200'} bg-white hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300`}
                  data-testid={`tarif-card-${type.value}`}
                >
                  <div className={`h-1.5 bg-gradient-to-r from-${type.color}-400 to-${type.color}-600`} />
                  <CardContent className="p-4 space-y-3">
                    {/* Header card */}
                    <div className="flex items-center justify-between gap-2">
                      <div className="flex items-center gap-2.5 min-w-0">
                        <div className={`flex-shrink-0 w-11 h-11 rounded-xl bg-${type.color}-100 border border-${type.color}-200 flex items-center justify-center text-2xl`}>
                          {type.icon}
                        </div>
                        <div className="min-w-0">
                          <div className="font-bold text-slate-900 text-sm leading-tight truncate" style={{ fontFamily: '"Outfit", system-ui, sans-serif' }}>{type.label}</div>
                          <div className="text-[9px] uppercase tracking-widest text-slate-400 mt-0.5">Type {type.value}</div>
                        </div>
                      </div>
                      {isDirty && (
                        <span className="flex-shrink-0 w-2 h-2 rounded-full bg-amber-500 animate-pulse" title="Non sauvegardé" />
                      )}
                    </div>

                    {/* Total estimation */}
                    <div className={`rounded-lg bg-gradient-to-br from-${type.color}-50 to-white border border-${type.color}-100 p-2.5`}>
                      <div className="text-[10px] uppercase tracking-widest text-slate-500">Prix avec urgence</div>
                      <div className={`text-2xl font-bold text-${type.color}-700 tabular-nums leading-none mt-0.5`} style={{ fontFamily: '"Outfit", system-ui, sans-serif' }}>
                        {(cfg.prix_cb * cfg.coef_urgence).toFixed(2)}€
                      </div>
                      <div className="text-[10px] text-slate-500 mt-0.5">{cfg.credits} crédits si paiement wallet</div>
                    </div>

                    {/* Inputs */}
                    <div className="space-y-2">
                      <div className="grid grid-cols-3 items-center gap-2">
                        <Label className="text-[10px] uppercase tracking-widest font-medium text-slate-500 col-span-1">Prix CB</Label>
                        <div className="col-span-2 relative">
                          <Input
                            type="number" step="0.5" min={0}
                            value={cfg.prix_cb}
                            onChange={(e) => updateConfigType(type.value, 'prix_cb', e.target.value)}
                            className="h-8 text-right pr-6 bg-slate-50 border-slate-200 focus:border-[#0a1e3f] tabular-nums"
                            data-testid={`tarif-input-prix_cb-${type.value}`}
                          />
                          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-slate-400">€</span>
                        </div>
                      </div>
                      <div className="grid grid-cols-3 items-center gap-2">
                        <Label className="text-[10px] uppercase tracking-widest font-medium text-slate-500 col-span-1">Crédits</Label>
                        <div className="col-span-2 relative">
                          <Input
                            type="number" step="1" min={0}
                            value={cfg.credits}
                            onChange={(e) => updateConfigType(type.value, 'credits', e.target.value)}
                            className="h-8 text-right pr-6 bg-slate-50 border-slate-200 focus:border-[#0a1e3f] tabular-nums"
                            data-testid={`tarif-input-credits-${type.value}`}
                          />
                          <Coins className="absolute right-2 top-1/2 -translate-y-1/2 h-3 w-3 text-amber-500" />
                        </div>
                      </div>
                      <div className="grid grid-cols-3 items-center gap-2">
                        <Label className="text-[10px] uppercase tracking-widest font-medium text-slate-500 col-span-1">Coef. urg.</Label>
                        <div className="col-span-2 relative">
                          <Input
                            type="number" step="0.1" min={1}
                            value={cfg.coef_urgence}
                            onChange={(e) => updateConfigType(type.value, 'coef_urgence', e.target.value)}
                            className="h-8 text-right pr-7 bg-slate-50 border-slate-200 focus:border-[#0a1e3f] tabular-nums"
                            data-testid={`tarif-input-coef_urgence-${type.value}`}
                          />
                          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-slate-400">×</span>
                        </div>
                      </div>
                    </div>

                    <Button
                      className={`w-full mt-2 text-xs h-8 ${isDirty
                        ? 'bg-[#0a1e3f] hover:bg-[#0B3C5D] text-white'
                        : 'bg-slate-100 hover:bg-slate-200 text-slate-700'}`}
                      size="sm"
                      variant={isDirty ? 'default' : 'outline'}
                      onClick={() => handleSaveConfigType(type.value)}
                      disabled={!isDirty}
                      data-testid={`save-type-${type.value}`}
                    >
                      <Save className="h-3.5 w-3.5 mr-1" />
                      {isDirty ? 'Sauvegarder' : 'À jour'}
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </TabsContent>
  );
};

export default TypesTab;
